<template>
  <div>
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
  <el-menu-item index="1">处理中心</el-menu-item>
  <el-submenu index="2">
    <template slot="title">我的工作台</template>
    <el-menu-item index="2-1">选项1</el-menu-item>
    <el-menu-item index="2-2">选项2</el-menu-item>
    <el-menu-item index="2-3">选项3</el-menu-item>
    <el-submenu index="2-4">
      <template slot="title">选项4</template>
      <el-menu-item index="2-4-1">选项1</el-menu-item>
      <el-menu-item index="2-4-2">选项2</el-menu-item>
      <el-menu-item index="2-4-3">选项3</el-menu-item>
    </el-submenu>
  </el-submenu>
  <el-menu-item index="3" disabled>消息中心</el-menu-item>
  <el-menu-item index="4"><a href="https://www.ele.me" target="_blank">订单管理</a></el-menu-item>
</el-menu>
  </div>
</template>

<script>
// 引入基本模板
// let echarts = require('../../../node_modules/echarts/lib/echarts')
// // 引入饼状图组件
// require('../../../node_modules/echarts/lib/chart/pie')
// // 引入提示框和title组件
// require('../../../node_modules/echarts/lib/component/tooltip')
// require('../../../node_modules/echarts/lib/component/title')


export default {
  data() {
      return{
          dynamicValidateForm: {
          domains: [{
            value: ''
          }],
          email: ''
        }
 
      };
  },
  created(){
    
  },
  mounted(){
    this.initData();
  },
  methods:{
    removeDomain(item) {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        this.dynamicValidateForm.domains.push({
          value: '',
          key: Date.now()
        });
      }
 
  }
}
</script>